import { product2ShoppingProduct } from 'redux-store/products/products.utils';
import { type IShoppingProductsMap, QUERY_PARAMS } from 'utils/constants';
import { getServiceSettings } from 'utils/getServiceSettings';
import { isProduction } from 'utils/platform';
import useQuery from 'utils/useQuery';

import { DexfSettingsFilterSegmentEnum, ProductOptionalFieldNameEnum } from '@inter-ikea-kompis/enums';
import { ProductService } from '@inter-ikea-kompis/services';
import type { IProduct } from '@inter-ikea-kompis/types';

let service: ProductService;

const getService = () => {
  if (!service) {
    service = new ProductService(getServiceSettings());
  }

  return service;
};

const getOptionalParams = () => {
  const futureDate = (!isProduction() && useQuery(QUERY_PARAMS.FUTURE_DATE)) || '';
  const segment = isProduction() ? DexfSettingsFilterSegmentEnum.production : DexfSettingsFilterSegmentEnum.development;

  return {
    customParams: {
      timestamp: futureDate,
      'filter.segment': segment
    }
  };
};

const getProductsData: () => Promise<IProduct[]> = () => {
  return getService().getApplicationProducts([...Object.values(ProductOptionalFieldNameEnum)], getOptionalParams());
};

const normalizedObject = (products: IProduct[]) => {
  return products.reduce<IShoppingProductsMap>((acc, product) => {
    acc[product.itemId] = product2ShoppingProduct(product);
    return acc;
  }, {});
};

export const getProducts = async () => {
  const products = await getProductsData();

  return normalizedObject(products);
};
